import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import PageTracker from "../common/PageTracker";
import routes from "./config";
import { Styles } from "../styles/styles";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <PageTracker />
      <Header />
      <Switch>
        {routes.map((routeItem) => {
          const routeKey = Array.isArray(routeItem.path)
            ? routeItem.path.join("|")
            : routeItem.path;
          return (
            <Route
              key={routeKey}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
